import CapiSettingReducer from 'store/capi-setting/reducers';

export default CapiSettingReducer;
